(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-reset-play-atoms.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-reset-play-atoms.js');
"use strict";

const _jotai = jotai,
  useSetAtom = _jotai.useSetAtom;
const atomWithSvSStorage = svs.lyckoplatsen.shared_utils.atomWithSvSStorage;
const getDefaultLocationName = svs.tur.lyckoplatsen.utils.getDefaultLocationName;
const useResetPlayAtoms = () => {
  const defaultPlayValues = svs.lyckoplatsen.components.page_play.jotai.defaultPlayValues;
  const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_play.jotai.atoms,
    disableCenterMapButtonAtom = _svs$lyckoplatsen$com.disableCenterMapButtonAtom,
    locationConfirmedAtom = _svs$lyckoplatsen$com.locationConfirmedAtom,
    mapLocationAtom = _svs$lyckoplatsen$com.mapLocationAtom,
    pinLocationAtom = _svs$lyckoplatsen$com.pinLocationAtom,
    pinLocationTypeAtom = _svs$lyckoplatsen$com.pinLocationTypeAtom,
    shouldShowPinAtom = _svs$lyckoplatsen$com.shouldShowPinAtom,
    newCustomerCampaignPlayAtom = _svs$lyckoplatsen$com.newCustomerCampaignPlayAtom;
  const charityAtom = svs.lyckoplatsen.shared_charity.jotai.atoms.charityAtom;
  const lyckoplatsenNameAtom = atomWithSvSStorage('lyckoplatsenName');
  const setPinLocation = useSetAtom(pinLocationAtom);
  const setPinLocationType = useSetAtom(pinLocationTypeAtom);
  const setMapLocation = useSetAtom(mapLocationAtom);
  const setDisableCenterMapButton = useSetAtom(disableCenterMapButtonAtom);
  const setLocationConfirmed = useSetAtom(locationConfirmedAtom);
  const setShouldShowPinAtom = useSetAtom(shouldShowPinAtom);
  const setLyckoplatsenName = useSetAtom(lyckoplatsenNameAtom);
  const setCharityAtom = useSetAtom(charityAtom);
  const setCampaignPlay = useSetAtom(newCustomerCampaignPlayAtom);
  return () => {
    setPinLocation(defaultPlayValues.pinLocationAtom);
    setPinLocationType(defaultPlayValues.pinLocationTypeAtom);
    setMapLocation(defaultPlayValues.mapLocationAtom);
    setDisableCenterMapButton(defaultPlayValues.showDisableMapButtonAtom);
    setLocationConfirmed(defaultPlayValues.locationConfirmedAtom);
    setShouldShowPinAtom(defaultPlayValues.shouldShowPinAtom);
    setLyckoplatsenName(getDefaultLocationName());
    setCharityAtom(null);
    setCampaignPlay(false);
  };
};
setGlobal('svs.lyckoplatsen.components.page_play.react.hooks.useResetPlayAtoms', useResetPlayAtoms);

 })(window);